import FormLabel from "components/Extra/FormLabel"
import { FormikProps } from "formik"
import React, { useRef } from "react"
import { Button, FormFeedback, InputGroup } from "reactstrap"

interface FormImageInputProps {
  label?: string
  info?: string
  required?: boolean
  validation: FormikProps<any>
  removeHandler?: () => void
  changeImageHandler: (e: React.ChangeEvent<HTMLInputElement>) => void
  icon?: React.ReactNode
  name: string
}

export const FormImageInput: React.FC<FormImageInputProps> = ({
  info,
  required,
  removeHandler,
  changeImageHandler,
  validation,
  label,
  icon,
  name,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  return (
    <div className="mb-3">
      <div className="">
        <FormLabel className="form-label" htmlFor="note" required={required}>
          {label}
        </FormLabel>

        <div
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => fileInputRef.current?.click()}
        >
          <InputGroup>
            <input
              type="number"
              className="form-control me-2"
              placeholder="Upload Image"
              readOnly
            />
            <input
              type="file"
              accept="image/*"
              multiple
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={changeImageHandler}
              placeholder="Attachments"
              className="form-control"
            />
            <span className="input-group-append">
              {icon ? (
                icon
              ) : (
                <i className="mdi mdi-camera font-size-20 input-group-text"></i>
              )}
            </span>
          </InputGroup>
        </div>
        <input
          type="file"
          accept="image/*"
          multiple
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={changeImageHandler}
        />
      </div>
      {info && (
        <div className="d-flex align-items-center gap-1 ms-2">
          <i className="bx bx-info-circle"></i>
          <FormFeedback type="invalid" className="d-block text-secondary">
            {info}
          </FormFeedback>
        </div>
      )}
      {/* @ts-ignore */}
      {validation.values[name] && (
        <div
          //  @ts-ignore
          key={validation.values[name]?.id}
          className="position-relative mt-1"
          style={{
            width: "80px",
            height: "80px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            overflow: "hidden",
          }}
        >
          <img
            // @ts-ignore
            src={validation.values[name]?.preview}
            // @ts-ignore
            alt={validation.values[name]?.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          <Button
            close
            onClick={removeHandler}
            style={{
              position: "absolute",
              top: "2px",
              right: "2px",
              background: "white",
              borderRadius: "50%",
              padding: "0",
              width: "20px",
              height: "20px",
            }}
          >
            <i className="mdi mdi-close"></i>
          </Button>
        </div>
      )}
    </div>
  )
}
